module.exports = __webpack_public_path__ + "img/security-on-animate.640b4b7d.svg";